import lozad from 'lozad';
import Swiper from 'swiper';
import { Navigation, EffectFade } from 'swiper/modules';
import GaPromotionTracking, { GaPromotionEventType } from '../../../core/components/ga-promotion-tracking';
export default class MainSlider {
    static heroSlider;
    static isNextArrowDisabled = false;
    static isPrevArrowDisabled = true;
    static $nextButton = $('.js__swiper-button-next');
    static $prevButton = $('.js__swiper-button-prev');
    static swiperOptions = {
        modules: [Navigation, EffectFade],
        speed: 600,
        navigation: {
            nextEl: '.js__swiper-button-next',
            prevEl: '.js__swiper-button-prev',
        },
        effect: 'fade',
        fadeEffect: {
            crossFade: true,
        },
    };
    static init() {
        const slidesCount = $('.js__swiper-hero .swiper-slide').not('.swiper-slide-duplicate').length;
        const isSingleSlide = slidesCount === 1 || slidesCount === 0;
        this.swiperOptions.on = {
            init: () => {
                this.setNavigationBackground();
                this.trackPromotionOnActiveSlide();
                const el = document.querySelectorAll('.js__lazy-video');
                const observer = lozad(el);
                observer.observe();
                // timeout needed to set arrow loop after slider is fully initialized
                setTimeout(() => {
                    this.setLoopPrev();
                    this.makeOnlyActiveSlideNavigatable();
                });
            },
            slideNextTransitionStart: () => {
                this.setNavigationBackground();
                this.trackPromotionOnActiveSlide();
                this.setLoopNext();
                this.makeOnlyActiveSlideNavigatable();
            },
            slidePrevTransitionStart: () => {
                this.setNavigationBackground();
                this.trackPromotionOnActiveSlide();
                this.setLoopPrev();
                this.makeOnlyActiveSlideNavigatable();
            },
        };
        this.heroSlider = new Swiper('.js__swiper-hero', this.swiperOptions);
        if (isSingleSlide) {
            $('.js__swiper-button-next, .js__swiper-button-prev').hide();
            const el = document.querySelectorAll('.js__lazy-video');
            const observer = lozad(el);
            observer.observe();
        }
        else {
            this.setFocusOnArrows();
        }
    }
    static setNavigationBackground() {
        const $activeSlide = $('.swiper-slide-active');
        const firstColor = $activeSlide.data('bg-color-1');
        const secondColor = $activeSlide.data('bg-color-2');
        $('.js__nav-item-link-wrapper').each((index, element) => {
            const $wrapper = $(element);
            const $background = $(element).find('.js__nav-item-background');
            $($background.get(1)).remove();
            $wrapper.prepend($background
                .first()
                .clone()
                .css({ background: `linear-gradient(60deg, ${firstColor} 0%, ${secondColor} 100%)` }));
            $background.first().css({ opacity: 0 });
        });
    }
    static trackPromotionOnActiveSlide() {
        const $activeSlide = $('.swiper-slide-active');
        GaPromotionTracking.trackEvent($activeSlide, GaPromotionEventType.View, true);
    }
    static makeOnlyActiveSlideNavigatable() {
        $('.js__swiper-button-next, .js__swiper-button-prev').prop('disabled', false);
        $('.swiper-slide.swiper-slide-active a').attr('tabindex', '0');
        $('.swiper-slide:not(.swiper-slide-active) a').attr('tabindex', '-1');
    }
    static setLoopPrev() {
        let arrowClick;
        this.$prevButton.off(arrowClick);
        this.isNextArrowDisabled = false;
        this.isPrevArrowDisabled = this.$prevButton.hasClass('swiper-button-disabled');
        if (this.isPrevArrowDisabled) {
            arrowClick = this.$prevButton.on('click', () => {
                this.heroSlider.slideTo(this.heroSlider.slides.length - 1);
                this.isNextArrowDisabled = true;
                this.isPrevArrowDisabled = false;
            });
        }
    }
    static setLoopNext() {
        let arrowClick;
        this.$nextButton.off(arrowClick);
        this.isNextArrowDisabled = this.$nextButton.hasClass('swiper-button-disabled');
        this.isPrevArrowDisabled = false;
        if (this.isNextArrowDisabled) {
            arrowClick = this.$nextButton.on('click', () => {
                this.heroSlider.slideTo(0);
                this.isPrevArrowDisabled = true;
                this.isNextArrowDisabled = false;
            });
        }
    }
    static setFocusOnArrows() {
        $('body').on('keydown', '.js__swiper-button-next, .js__swiper-button-prev', e => {
            if (e.key === 'Enter' || e.key === ' ') {
                setTimeout(() => {
                    $(e.currentTarget).trigger('focus');
                }, 200);
            }
        });
    }
}
